import { c as _c } from "react/compiler-runtime";
import BackButton from './components/BackButton';
import styles from './index.module.scss';
export default function CommandBox() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className={styles.command_wrapper}><BackButton /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}